var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandlix(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 809.6 187.7",
    style: {
      enableBackground: "new 0 0 809.6 187.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h26.6v161.4h83.5v24.2H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.8,112.1V164c0,4.2,1.4,6.2,4.2,6.2c2.9,0,7.5-2.2,13.7-6.5v14.7c-5.5,3.5-9.9,6-13.2,7.2 s-6.8,1.9-10.4,1.9c-10.4,0-16.5-4.1-18.3-12.2c-10.3,8-21.2,12-32.8,12c-8.5,0-15.6-2.8-21.2-8.4c-5.7-5.6-8.5-12.7-8.5-21.2 c0-7.7,2.8-14.6,8.3-20.7c5.5-6.1,13.4-10.9,23.6-14.4l30.9-10.6v-6.5c0-14.7-7.4-22-22-22c-13.2,0-26,6.8-38.5,20.5V77.6 C131.8,66.5,145.3,61,163,61c13.2,0,23.8,3.5,31.7,10.4c2.7,2.2,5,5.2,7.2,8.8c2.1,3.7,3.5,7.4,4.1,11 C206.5,94.9,206.8,101.8,206.8,112.1z M183,161.4v-36.3l-16.2,6.2c-8.2,3.3-14.1,6.6-17.5,9.9c-3.4,3.3-5.1,7.5-5.1,12.4 c0,5,1.6,9.2,4.8,12.4c3.2,3.2,7.4,4.8,12.6,4.8C169.3,170.8,176.5,167.7,183,161.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270.3,63.4v15.5c10.8-12,23.1-17.9,36.8-17.9c7.6,0,14.7,2,21.2,5.9c6.6,3.9,11.5,9.3,14.9,16.2 c3.4,6.9,5.1,17.7,5.1,32.6v69.9h-24.2v-69.6c0-12.5-1.9-21.4-5.7-26.8c-3.8-5.4-10.2-8-19.1-8c-11.4,0-21.1,5.7-29.1,17.1v87.3 h-24.7V63.4H270.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.6,0H488v185.5h-51.7c-18.1,0-32.5-5.7-43.2-17.1s-16.1-26.7-16.1-46c0-18,5.6-32.8,16.9-44.4 c11.3-11.6,25.7-17.4,43.2-17.4c8.1,0,17,1.7,26.6,5.2V0z M463.6,164.8V87.4c-7.5-3.8-15.1-5.7-22.8-5.7c-12,0-21.6,3.9-28.8,11.8 c-7.1,7.9-10.7,18.5-10.7,31.9c0,12.6,3.1,22.3,9.3,29.1c3.7,4.1,7.7,6.8,11.8,8.2c4.2,1.4,11.6,2.1,22.4,2.1H463.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M494.1,0h26.6v161.4h83.5v24.2H494.1V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M643.6,11c4,0,7.4,1.4,10.2,4.1c2.8,2.7,4.2,6.1,4.2,10.1c0,3.9-1.4,7.3-4.2,10.1c-2.8,2.8-6.2,4.2-10.2,4.2 c-3.7,0-7-1.4-9.8-4.3c-2.8-2.9-4.2-6.2-4.2-10c0-3.7,1.4-7,4.2-9.9C636.6,12.4,639.9,11,643.6,11z M631.6,62.4h24.2v122.2h-24.2 V62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M775.1,62.4H806l-50.3,60.2l53.9,62h-31l-38.4-43.8L704,184.5h-30.4l51.4-61.9l-51.4-60.3h30.5l36.2,41.9 L775.1,62.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandlix);
export default __webpack_public_path__ + "static/media/landlix.070aae70a3f25f0bbbc79ed7b6d2763c.svg";
export { ForwardRef as ReactComponent };